webpackJsonp([274765520089920],{

/***/ 1567:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"TaskCategoryInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-task-category-input-8a01e0cb11c69747f04f.js